module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('industry-single', {
    scopedSlots: _vm._u([{
      key: "hero",
      fn: function() {
        return [_c('hero-full', {
          attrs: {
            "imageName": "industries/commercial-auto-banner.jpg",
            "altText": "Truck"
          },
          scopedSlots: _vm._u([{
            key: "content",
            fn: function() {
              return [_c('h1', [_vm._v("Commercial Auto Loans")]), _vm._v(" "), _c('p', [_vm._v("Commercial Auto Financing & Vehicle Loans for businesses")])]
            },
            proxy: true
          }])
        })]
      },
      proxy: true
    }, {
      key: "form-section",
      fn: function() {
        return [_c('FormSection', {
          scopedSlots: _vm._u([{
            key: "content",
            fn: function() {
              return [_c('h2', [_c('span', [_vm._v("American Credit:")]), _vm._v(" Empowering Business Owners everyday\n          with Commercial Auto Financing.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          Reliable & consistently operational commercial vehicles is is\n          imperative for your business. Commercial vehicles serve many\n          purposes such as transporting goods, moving workers from Point A to\n          Point B, or transporting equipment & supplies to job sites. If your\n          commercial vehicles cause a delay in your business efficiency,\n          customers will quickly move on to a competitor with better &\n          reliable vehicles & equipment. There is no room for error."), _c('br'), _c('br'), _vm._v("\n\n          American Credit understands your need for instant commercial auto\n          financing to purchase new or used vehicles for your business. Read\n          on and see how we help businesses like yours everyday with quick &\n          simple commercial auto loans.\n        ")])]
            },
            proxy: true
          }, {
            key: "logos",
            fn: function() {
              return [_c('div', {
                staticClass: "row"
              }, [_c('div', {
                staticClass: "col-12 col-md-5 order-md-2 d-flex"
              }, [_c('div', {
                staticClass: "row align-items-center logos-brands"
              }, [_c('div', {
                staticClass: "col-6 col-md-12"
              }, [_c('img', {
                attrs: {
                  "src": "/static/assets/imgs/industries/nefa-logo.png",
                  "alt": "NEFA logo"
                }
              })]), _vm._v(" "), _c('div', {
                staticClass: "col-6 col-md-12"
              }, [_c('a', {
                attrs: {
                  "href": "https://www.bbb.org/us/ca/palo-alto/profile/financial-services/american-credit%C2%AE-inc-1216-1079741",
                  "target": "_blank"
                }
              }, [_c('img', {
                attrs: {
                  "src": "/static/assets/imgs/industries/bbba-logo.png",
                  "alt": "BBBA logo"
                }
              })])])])]), _vm._v(" "), _c('div', {
                staticClass: "col-12 col-md-7"
              }, [_c('img', {
                attrs: {
                  "src": "/static/assets/imgs/industries/google-review.png",
                  "alt": "Google Review"
                }
              })])])]
            },
            proxy: true
          }])
        })]
      },
      proxy: true
    }, {
      key: "first-row",
      fn: function() {
        return [_c('RowSection', {
          attrs: {
            "img-side": "left",
            "imageName": "industries/commercial-auto-equipment-loans.jpg",
            "altText": "Commercial Vehicle Workers",
            "backgroundPrimary": "#00234D",
            "backgroundSecondary": "#F6F9FE",
            "ctaButtonTitle": "Apply for a Commercial Truck Loan"
          },
          scopedSlots: _vm._u([{
            key: "content",
            fn: function() {
              return [_c('h2', [_vm._v("Instant Commercial Truck Loans")]), _vm._v(" "), _c('p', [_vm._v("\n          Need to add a few commercial trucks to your small business?\n          Interested in scaling your business with a large commercial truck\n          fleet? Use your Commercial Auto Loan to purchase any commercial\n          trucks for long haul or short haul, such as day cabs, sleeper\n          trucks, flatbed trucks, refrigerated trucks, box trucks & more."), _c('br'), _c('br'), _vm._v("\n\n          American Credit has over 20+ years of commercial auto financing\n          experience. We work with you to understand your unique vehicle\n          needs, and then secure quick funding so you can get back to work\n          asap. Apply for your commercial auto loan today!\n        ")])]
            },
            proxy: true
          }])
        })]
      },
      proxy: true
    }, {
      key: "second-row",
      fn: function() {
        return [_c('RowSection', {
          attrs: {
            "img-side": "right",
            "imageName": "industries/commercial-auto-working-capital.jpg",
            "altText": "Buses"
          },
          scopedSlots: _vm._u([{
            key: "content",
            fn: function() {
              return [_c('h2', [_vm._v("\n          Commercial Auto Loans for Specialty Vehicles, Buses & Cargo Vans\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          Need financing for more specialized vocational commercial vehicles?\n          American Credit helps you secure financing for speciality commercial\n          vehicles everyday!"), _c('br'), _c('br'), _vm._v("\n          Use your Commercial Auto Financing to purchase vocational vehicles\n          such as recycling haulers, cargo vans, charter buses, moving trucks,\n          tanker trucks, tow trucks, scrap trucks, emergency vehicles,\n          compactors, medium duty work trucks, shredder trucks, gas-equipped\n          trucks and more!\n        ")])]
            },
            proxy: true
          }])
        })]
      },
      proxy: true
    }, {
      key: "third-row",
      fn: function() {
        return [_c('IconsGrid', {
          attrs: {
            "gridElements": _vm.gridItems
          },
          scopedSlots: _vm._u([{
            key: "title",
            fn: function() {
              return [_vm._v("Geared to Your Needs and Your Business")]
            },
            proxy: true
          }])
        })]
      },
      proxy: true
    }, {
      key: "fourth-row",
      fn: function() {
        return [_c('TablesSection', {
          attrs: {
            "tables": _vm.tableItems,
            "ctaButtonTitle": "Apply for a Commercial Truck Loan"
          },
          scopedSlots: _vm._u([{
            key: "title",
            fn: function() {
              return [_vm._v("Commercial Auto Loan Requirements")]
            },
            proxy: true
          }, {
            key: "text",
            fn: function() {
              return [_vm._v("Minimum loan requirements to expedite approval & secure quick\n        funding.")]
            },
            proxy: true
          }])
        })]
      },
      proxy: true
    }, {
      key: "fifth-row",
      fn: function() {
        return [_c('RowSection', {
          staticClass: "lei-section",
          attrs: {
            "img-side": "right",
            "imageName": "industries/Lei-li-formal.jpeg",
            "altText": "photo Dr. Lei Li, CEO of American Credit, Inc., in blue suit smiling"
          },
          scopedSlots: _vm._u([{
            key: "content",
            fn: function() {
              return [_c('h2', [_c('span', [_vm._v("American Credit:")]), _vm._v(" The Difference You Can Trust")]), _vm._v(" "), _c('p', [_vm._v("\n          Your business is not JUST a business. It’s YOURS. It’s your\n          livelihood. It’s your passion. American Credit completely\n          understands this. We help business owners just like you everyday, by\n          taking a wholistic approach to business financing.\n          "), _c('strong', [_vm._v("Dr. Lei Li, PhD, CFA, & CEO of American Credit")]), _vm._v(", is\n          an Economist who uses his 20+ years of industry experience to help\n          business owners achieve their American Dream:\n          "), _c('strong', [_vm._v("successful business ownership")]), _vm._v(". "), _c('br'), _c('br'), _vm._v("\n          Whatever financial situation you’re in, American Credit has your\n          back. Apply for your business loan today!\n        ")])]
            },
            proxy: true
          }, {
            key: "button-contact",
            fn: function() {
              return [_c('contact-info', {
                staticClass: "d-none d-md-flex",
                attrs: {
                  "imageName": "Lei_Li.png",
                  "altText": "Lei's photo",
                  "title": "Call Lei",
                  "contactType": "Service",
                  "phoneNumber": "650-885-8055"
                }
              })]
            },
            proxy: true
          }])
        })]
      },
      proxy: true
    }, {
      key: "google-reviews",
      fn: function() {
        return [_c('div', {
          staticClass: "elfsight-app-8279c03d-9a65-4465-b949-ecb8d18697e0"
        })]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b1af463c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/industries/commercialVehicleLoans.vue
// module id = 2003
// module chunks = 5